import CalendarEvent from '../CalendarEvent';
import ScrollableList from '../ScrollableList';

import * as style from './style.module.css';

const CalendarList = ({ isScrollable = false, events = [], order = 'DESC', handleDelete = null }) => {
    const Elem = (props) => isScrollable ? <ScrollableList arrowSpace="var(--space-medium)" shadowHeight="124px" {...props} /> : <div {...props} />

    const orderedEvents = events.map(e => ({
        ...e,
        computedDate: (e.startDate || e.endDate),
    })).sort((a, b) => {
        if (a.computedDate > b.computedDate) {
            return order === 'DESC' ? -1 : 1;
        }
        if (a.computedDate < b.computedDate) {
            return order === 'DESC' ? 1 : -1;
        }
        return 0
    });

    return <Elem className={isScrollable ? style.isScrollable : style.grid}>
        {orderedEvents.map(e => <CalendarEvent key={e.id} insideScrollable={isScrollable} {...e} onDelete={handleDelete ? handleDelete(e.id) : null} />)}
    </Elem>;
}

export default CalendarList;
